var CookieConsentModule = function () {

    var self = this;
  
    /**
     * @var array
     */
    self.cookiesPopup = jQuery('#cookies-popup');
    
    if (self.cookiesPopup.length === 0) {
        return;
    }
  
    self.cookieTypes = [
      'functionality', 
      'analytics', 
      'marketing', 
      'performance'
    ];
  
    window.wp_consent_type = 'optin';
  
    self.showPopup = function() {
      
      var showPopup = self.cookieTypes.every(function(cookieType) {
          return consent_api_get_cookie(`${consent_api.cookie_prefix}_${cookieType}`).length === 0;
      });
      
      if (showPopup && jQuery('#cookies-preferences-form').length === 0) {
        self.cookiesPopup.modal('show');
      }
    
    }

    self.setCookiePreferences = function() {
      if (jQuery('#cookies-preferences-form').length === 0) {
          return;
      }

      var 
          form = jQuery('#cookies-preferences-form')
      ;

      self.cookieTypes.forEach(function(cookieType) {
          var 
              cookieConsent = consent_api_get_cookie(`${consent_api.cookie_prefix}_${cookieType}`),
              input = form.find(`#${cookieType}_cookies`)
          ;

          input.prop("checked", (cookieConsent.length > 0 && cookieConsent === 'allow'));
      });
  }

    self.handleOptIn = function() {
      self.cookieTypes.forEach(function(cookieType){
        wp_set_consent(cookieType, 'allow');
      })
    }
  
    self.handleOptOut = function() {
      self.cookieTypes.forEach(function(cookieType){
        wp_set_consent(cookieType, 'deny');
      })
    }
  
    self.updateConsent = function(event) {
      event.preventDefault();
      
      var form = jQuery(event.target);
    
        self.cookieTypes.forEach(function(cookieType) {
  
        var input = form.find(`#${cookieType}_cookies`)
          wp_set_consent(cookieType, input.is(":checked") ? 'allow' : 'deny');
        })
  
        window.location = document.referrer ?? false
  
    }
  
    self.toggleCookiePreferences = function(event) {
       var 
        target = jQuery(event.target),
        form = target.closest('form'),
        enableCookies = target.data('store-all-cookies') ? true : false
      ;
  
      self.cookieTypes.forEach(function(cookieType) {
        jQuery(`#${cookieType}_cookies`).prop('checked', enableCookies);
      })
    }
  
  
    
  
    /**
     * Bind events
     */
    self.bindEvents = function () {
        EventBus.subscribe('run-modules', function() {
          self.showPopup()
          self.setCookiePreferences()
        });
        jQuery(document).on('click', '[data-opt-in]', self.handleOptIn);
        jQuery(document).on('click', '[data-opt-out]', self.handleOptOut);
        jQuery(document).on('submit', '#cookies-preferences-form', self.updateConsent);
        jQuery(document).on('click', '[data-store-all-cookies]', self.toggleCookiePreferences);
  
    };
  
    self.bindEvents();
  
  };
  
  EventBus.subscribe('init-modules', function () {
    new CookieConsentModule();
  })